import { forwardRef } from "react";
import { cn } from "@/lib/utils";

const VARIANTS = {
    primary: "bg-brand-blue text-white",
    secondary: "bg-brand-orange text-white",
    yellow: "bg-brand-yellow text-ink",
    green: "bg-brand-green text-ink",
    white: "bg-white text-ink",
    ink: "bg-ink text-cream",
};

const SIZES = {
    sm: "text-xs px-4 py-2",
    md: "text-sm px-5 py-3",
    lg: "text-base px-7 py-4",
};

const BrutalButton = forwardRef(function BrutalButton(
    {
        as: Component = "button",
        variant = "primary",
        size = "md",
        className,
        children,
        type,
        ...props
    },
    ref
) {
    const isButton = Component === "button";
    return (
        <Component
            ref={ref}
            type={isButton ? type || "button" : undefined}
            className={cn(
                "inline-flex items-center justify-center gap-2 font-display font-extrabold uppercase tracking-wide",
                "border-2 border-ink rounded-xl shadow-brutal-sm",
                "transition-all duration-150 ease-out",
                "hover:-translate-y-1 hover:-translate-x-1 hover:shadow-brutal",
                "active:translate-y-0 active:translate-x-0 active:shadow-none",
                "disabled:opacity-60 disabled:pointer-events-none",
                VARIANTS[variant],
                SIZES[size],
                className
            )}
            {...props}
        >
            {children}
        </Component>
    );
});

export default BrutalButton;
